import { assertNever } from '@kofno/piper';
import { L, T } from '../../../../../Translations';
import { utcDateToLocalDate } from '../../Functions';
import { RunChoice } from './CourseOptions';

// Who picks the run of a course with several. An email invite enrolls people
// in a run the admin picks; a shared URL points at the course and the
// participant picks the run on landing (DVLP-8060).
export type RunChooser = 'admin' | 'participant';

// Run start dates are calendar dates; read as UTC midnight they show a day
// early west of Greenwich.
export const startDate = (date: Date) => (
  <L localizeable={utcDateToLocalDate(date)} format="short-month-day-year" />
);

function SeveralRuns({ count, chooser }: { count: number; chooser: RunChooser }) {
  switch (chooser) {
    case 'admin':
      return <T kind="Choose from {{count}} start dates" count={count} />;
    case 'participant':
      return <T kind="Participants choose from {{count}} start dates" count={count} />;
    default:
      return assertNever(chooser);
  }
}

// When a course starts, in one phrase: the catalog rows say it. The chosen
// course's card lists the dates themselves (StartDateChips).
function WhenItStarts({ choice, chooser }: { choice: RunChoice; chooser: RunChooser }) {
  switch (choice.kind) {
    case 'start-anytime':
      return <T kind="Start anytime" />;
    case 'single-run':
      return <T kind="Starts <date/>" date={startDate(choice.run.startOn)} />;
    case 'several-runs':
      return <SeveralRuns count={choice.runs.length} chooser={chooser} />;
    default:
      return assertNever(choice);
  }
}

export default WhenItStarts;
